module.exports = __webpack_public_path__ + "static/media/mail_icon.50b0d730.svg";